import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { MatTableDataSource, MatDialog, PageEvent, MatPaginator, MatSnackBar } from '@angular/material';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ComponentPageTitle } from 'src/app/page-title/page-title.component';
import { AppServiceService } from 'src/app/services/app-service.service';
import { BusquedaService } from '../busqueda.service';
import { CreateService } from '../createservice';
import { GatewayService } from 'src/app/gateway.service';
import { FiltroPaisService } from '../filtro-pais.service';
import { LocalSaveService } from 'src/app/services/local-save-service.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { FormGroup, FormControl } from '@angular/forms';
import { DescargarLotesComponent } from 'src/app/home/descargar-lotes/descargar-lotes.component';
import { TipoServicioService } from '../tipo-servicio.service';

/**
 * RF-04 — Reporte de auditoria de reasignaciones.
 * Ver: context/asignaciones/ADR-001-RF04-reporte-reasignaciones.md
 */
@Component({
  selector: 'app-repo-reasignacion',
  templateUrl: './repo-reasignacion.component.html',
  styleUrls: ['./repo-reasignacion.component.scss']
})
export class RepoReasignacionComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();

  agentes: any[] = [{ idagente: 0, nombre: 'Todos' }];

  bandas = [
    { id: '', name: 'Todos' },
    { id: 'AM', name: 'AM' },
    { id: 'PM', name: 'PM' }
  ];

  motivos = [
    { id: '', name: 'Todos' },
    { id: 'ausencia_tecnico', name: 'Ausencia tecnico' },
    { id: 'cambio_banda', name: 'Cambio banda' },
    { id: 'manual', name: 'Manual' },
    { id: 'otro', name: 'Otro' }
  ];

  // Rango maximo del backend: 90 dias. Default: ultimos 30 dias.
  grupoVal = new FormGroup({
    BUSCAR: new FormControl(''),
    TECNICO: new FormControl(0),
    BANDA: new FormControl(''),
    MOTIVO: new FormControl(''),
    FECHAINI: new FormControl(this.defaultFechaIni()),
    FECHAFIN: new FormControl(new Date())
  });

  tableColumns: string[] = [
    'FALLA',
    'TECNICO_ORIGINAL',
    'TECNICO_NUEVO',
    'BANDA',
    'URGENCIA',
    'MOTIVO',
    'FECHA_DESASIGNACION',
    'FECHA_REASIGNACION'
  ];

  dataSource = new MatTableDataSource<any>([]);
  resultsLength = 0;
  pageSize = 10;
  actpage = 0;
  idpais;
  FILTER;
  private subscription: Subscription;
  private subscriptioncreate: Subscription;
  private subscriptionpais: Subscription;

  @ViewChild('paginatortable') paginatortable: MatPaginator;

  constructor(
    private router: Router,
    private spinner: NgxSpinnerService,
    private gateway: GatewayService,
    public pageTitle: ComponentPageTitle,
    public _appservice: AppServiceService,
    public _busqueda: BusquedaService,
    public _create: CreateService,
    private dialog: MatDialog,
    public _filtroPais: FiltroPaisService,
    private localSave: LocalSaveService,
    private snackbar: MatSnackBar,
    private _tipoServicio: TipoServicioService
  ) { }

  async ngOnInit() {
    const user = this.localSave.get('usuarioPGV');
    if (!user || (user.idrol != 1 && user.idrol != 27)) {
      this.router.navigate(['/home']);
      return;
    }
    this.idpais = this.localSave.get('pais');
    await this.getTecnicosxContrata();
    this.get(0);
    this.pageTitle.title = 'Bitácora de Reasignaciones';

    this.subscription = this._busqueda.notifyObservable$.pipe(takeUntil(this.destroy$)).subscribe(
      res => { this.filtrarAgente(res.filtro); }
    );
    this.subscriptioncreate = this._create.notifyObservable$.pipe(takeUntil(this.destroy$)).subscribe(
      res => { }
    );
    this.subscriptionpais = this._filtroPais.notifyObservable$.pipe(takeUntil(this.destroy$)).subscribe(
      res => {
        this.idpais = res.IDPAIS;
        this.get(0);
      }
    );
    this._tipoServicio.notifyObservable$.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.getTecnicosxContrata().then(() => this.get(0));
    });
  }

  private defaultFechaIni(): Date {
    const d = new Date();
    d.setDate(d.getDate() - 30);
    return d;
  }

  private formatDate(value: any): string {
    if (!value) return null;
    const d = value instanceof Date ? value : new Date(value);
    if (isNaN(d.getTime())) return null;
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  }

  private buildParams(inicio: number, numElementos: number) {
    return {
      FECHAINI: this.formatDate(this.grupoVal.controls.FECHAINI.value),
      FECHAFIN: this.formatDate(this.grupoVal.controls.FECHAFIN.value),
      ID_TECNICO_ORIGINAL: this.grupoVal.controls.TECNICO.value || null,
      BANDA: this.grupoVal.controls.BANDA.value || null,
      MOTIVO: this.grupoVal.controls.MOTIVO.value || null,
      INICIO: inicio,
      NUM_ELEMENTOS: numElementos
    };
  }

  filter = '';
  keyDownFunction(event) {
    if (event.keyCode == 13) {
      this.filtrogeneral();
    } else if (event.keyCode == 8 && this.filter == '') {
      this.filtrogeneral();
    }
  }

  filtrogeneral() {
    if (this.paginatortable) {
      this.paginatortable.firstPage();
    }
    this.get(0);
  }

  getTecnicosxContrata() {
    return new Promise((resolve, reject) => {
      this.gateway.get('gettecnicosxcontrata', {
        IDPAIS: this.idpais,
        IDDISTRIBUIDOR: (this._tipoServicio.getValorActual().IDU || null),
        IDPADRE: (this._tipoServicio.getValorActual().IDU || null),
        IDAREA: (this._tipoServicio.getValorActual().IDAREA || null)
      }).then((result: any) => {
        if (result && result.rows && result.rows.length > 0) {
          this.agentes = result.rows.slice();
          this.agentes.unshift({ idagente: 0, nombre: 'Todos' });
        }
        resolve(true);
      }).catch((e) => { reject(e); });
    });
  }

  get(page) {
    const fechaini = this.formatDate(this.grupoVal.controls.FECHAINI.value);
    const fechafin = this.formatDate(this.grupoVal.controls.FECHAFIN.value);

    if (!fechaini || !fechafin) {
      this.snackbar.open('Debe seleccionar rango de fechas', 'Cerrar', { duration: 3000 });
      return;
    }

    const params = this.buildParams(page * this.pageSize, this.pageSize);
    this.spinner.show();

    this.gateway.save('getReporteReasignaciones', params).then((result: any) => {
      this.dataSource = new MatTableDataSource(result && result.rows ? result.rows : []);

      // Conteo en paralelo para paginacion
      this.gateway.save('getContReporteReasignaciones', params).then((cRes: any) => {
        this.resultsLength = (cRes && cRes.rows && cRes.rows[0] ? cRes.rows[0].total : 0);
        this.spinner.hide();
      }).catch(() => {
        this.resultsLength = 0;
        this.spinner.hide();
      });
    }).catch((e) => {
      this.spinner.hide();
      const msg = (e && e.error && e.error.error) ? e.error.error : 'Error al cargar el reporte';
      this.snackbar.open(msg, 'Cerrar', { duration: 4000 });
    });
  }

  cambioElementos(event?: PageEvent) {
    this.actpage = event.pageIndex;
    this.pageSize = event.pageSize;
    this.get(event.pageIndex);
  }

  filtrarAgente(data) {
    this.FILTER = data;
    this.get(0);
  }

  descargar() {
    const fechaini = this.formatDate(this.grupoVal.controls.FECHAINI.value);
    const fechafin = this.formatDate(this.grupoVal.controls.FECHAFIN.value);

    if (!fechaini || !fechafin) {
      this.snackbar.open('Debe seleccionar rango de fechas para descargar', 'Cerrar', { duration: 3000 });
      return;
    }

    const dialogRef = this.dialog.open(DescargarLotesComponent, {
      disableClose: true,
      width: '700px',
      data: {
        cantPorPagina: 1000,
        nombreServicioCantRegistros: 'getContReporteReasignaciones',
        nombreServicioRegistros: 'descargarReporteReasignaciones',
        params: {
          FECHAINI: fechaini,
          FECHAFIN: fechafin,
          ID_TECNICO_ORIGINAL: this.grupoVal.controls.TECNICO.value || null,
          BANDA: this.grupoVal.controls.BANDA.value || null,
          MOTIVO: this.grupoVal.controls.MOTIVO.value || null
        }
      }
    });

    dialogRef.afterClosed().subscribe(() => { });
  }

  motivoLabel(id: string): string {
    const m = this.motivos.find(x => x.id === id);
    return m ? m.name : id;
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    if (this.subscription) this.subscription.unsubscribe();
    if (this.subscriptioncreate) this.subscriptioncreate.unsubscribe();
    if (this.subscriptionpais) this.subscriptionpais.unsubscribe();
  }
}
